<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{lbl_loading}}</span>
</div>
<div class="card">
    <p-toolbar styleClass="p-mb-4" *ngIf="device != '2'">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <p-table #dt [value]="lstWorkShops" [rows]="10" [paginator]="true"
        [globalFilterFields]="['f0.anio','chr.name','wst.wsName','f0.strDate','f0.fromTime','wrkStatName']"
        [(selection)]="selectedProducts" [rowHover]="true" dataKey="wrksId"
        currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
        [showCurrentPageReport]="true" responsive="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{lbl_my_workshops}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>
            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-plus" (click)="openNew()" class="p-mr-4 z-5"
                    pTooltip="{{lbl_new_record}}" tooltipPosition="bottom" [disabled]="isDisabled"></button>

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"
                    *ngIf="device != '2'"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"
                    *ngIf="device != '2'"></button>
            </span>
        </ng-template>

        <!--
        Solicitado por Ofelia
        Presentar las columnas siguientes
        •	Columna ID col el  ID servicio.
        •	Columna EPG con el  ID + Alias EPG: solo aparece informada en los servicios tipo etapa
        •	Columna Iglesia con el nombre de la Parroquia
        •	Columna Servicio con el tipo de Servicio
        •	Columna Fecha
        •	Columna Hora
        •	Columna estatus  

        Mostar solo los servicios con Estado < 05. 
        -->
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="f0.wrksId">{{lbl_id}} <p-sortIcon field="f0.wrksId"></p-sortIcon></th>
                <th pSortableColumn="f0.anio">{{lbl_period}} <p-sortIcon field="f0.anio"></p-sortIcon></th>
                <th pSortableColumn="chr.name">{{lbl_church}} <p-sortIcon field="chr.name"></p-sortIcon></th>
                <th pSortableColumn="wst.wsName">{{lbl_service}} <p-sortIcon field="wst.wsName"></p-sortIcon></th>
                <th pSortableColumn="f0.strDate">{{lbl_date}} <p-sortIcon field="f0.strDate"></p-sortIcon></th>
                <th pSortableColumn="f0.fromTime">{{lbl_time}} <p-sortIcon field="f0.fromTime"></p-sortIcon></th>
                <th pSortableColumn="wrkStatName">{{lbl_status}} <p-sortIcon field="wrkStatName"></p-sortIcon></th>
                <th style="width: 14rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-workshop>
            <tr>
                <td>{{workshop.f0.wrksId}}</td>
                <td>{{workshop.f0.anio}} - {{workshop.f0.period}}</td>
                <td>{{workshop.chr.name}} </td>
                <!-- COORD -->
                <td>
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: start;">

                        <div class="coordName">
                            <!-- <span>Nombre: </span> -->
                            <span style="font-weight: bold;" class="coordName-nowrap">{{workshop.epgName ?
                                workshop.epgName : ' '}}</span>
                        </div>

                        <div class="coordName">
                            <!--  <span>Email: </span> -->
                            <span class="coordName-nowrap">{{workshop.wst? workshop.wst.wsName:'S/N'}}</span>
                        </div>
                    </div>
                </td>
                <td>{{formatDate(workshop.f0.strDate)}}</td>
                <td>{{workshop.f0.fromTime}}</td>
                <td>{{workshop.wrkStatName}}</td>

                <td>
                    <button pButton pRipple icon="pi pi-calendar-plus" class="p-button-rounded p-button-info p-mr-2"
                        (click)="openWorkShopAssistance(workshop)" pTooltip="{{lbl_attendance}}"></button>
                    <button pButton
                        *ngIf="workshop.f0.serTyp!='16' && workshop.f0.serTyp!='17' && workshop.f0.serTyp!='18'" pRipple
                        icon="pi pi-user-plus" class="p-button-rounded p-button-success p-mr-2"
                        (click)="openWorkShopParticipant(workshop)" pTooltip="{{lbl_sign_up}}"></button>
                    <button pButton
                        *ngIf="(workshop.f0.serTyp=='16' || workshop.f0.serTyp=='17' || workshop.f0.serTyp=='18') && workshop.f0.status!='C'"
                        pRipple icon="pi pi-user-plus" class="p-button-rounded p-button-success p-mr-2"
                        pTooltip="{{lbl_Secretary_can_add_more_partici}}, {{lbl_option}}: SFPG"></button>
                    <button pButton *ngIf="workshop.f0.status!='C'" pRipple icon="pi pi-pencil"
                        class="p-button-rounded p-button-warning p-mr-2" (click)="openWorkShopDetail(workshop)"
                        pTooltip="{{lbl_edit}}"></button>
                    <button pButton *ngIf="workshop.f0.status=='C'" pRipple icon="pi pi-search"
                        class="p-button-rounded p-button-secondary p-mr-2" (click)="openWorkShopDetail(workshop)"
                        pTooltip="{{lbl_select}}"></button>
                    <button pButton
                        *ngIf="(workshop.f0.status=='N' || workshop.f0.status=='P') && workshop.f0.serTyp!='16' && workshop.f0.serTyp!='17' && workshop.f0.serTyp!='18'"
                        pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteWorkShop(workshop)" pTooltip="{{lbl_delete}}"></button>
                    <button pButton pRipple icon="pi pi-check-circle" class="p-button-rounded p-button-success p-mr-2"
                        (click)="showDialogStatus(workshop)" pTooltip="{{lbl_status}}"
                        *ngif="security && security.levelId!='G'"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{lbl_total}} {{lstWorkShops ? lstWorkShops.length : 0 }} {{lbl_services}}.
            </div>
        </ng-template>
    </p-table>
</div>

<p-dialog [(visible)]="workShopDialog" [style]="{width: '450px'}" header="WorkShop Details" [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="p-field">
            <label for="name">Estado / Depto/ Provincia</label>
            <p-dropdown editable="true" optionLabel=""></p-dropdown>

            <small class="p-invalid" *ngIf="submitted && !workshop.name">Information is required.</small>
        </div>
        <div class="p-field">
            <label for="name">Parroquia / Lugar</label>
            <p-dropdown editable="true" optionLabel=""></p-dropdown>

            <small class="p-invalid" *ngIf="submitted && !workshop.name">Information is required.</small>
        </div>
        <div class="p-field">
            <label for="name">Servicio a impartir</label>
            <p-dropdown editable="true" optionLabel=""></p-dropdown>

            <small class="p-invalid" *ngIf="submitted && !workshop.name">Information is required.</small>
        </div>
        <div class="p-field">
            <label for="name">Fecha de Inicio</label>

            <p-inputMask mask="99/99/9999" [(ngModel)]="val3" placeholder="15/12/2024"
                slotChar="dd/mm/yyyy"></p-inputMask>
            <small class="p-invalid" *ngIf="submitted && !workshop.name">Information is required.</small>
        </div>
        <div class="p-field">
            <label for="name">Hora Inicio</label>
            <p-calendar [(ngModel)]="date8" [timeOnly]="true" inputId="timeonly"></p-calendar>

            <small class="p-invalid" *ngIf="submitted && !workshop.name">Information is required.</small>
        </div>

        <div class="p-field">
            <label for="name">Comentarios</label>
            <input type="text" pInputText id="name" [(ngModel)]="workshop.name" required autofocus />
            <small class="p-invalid" *ngIf="submitted && !workshop.name">Information is required.</small>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


<p-dialog header="Cambiar Estatus" [(visible)]="displayModalStatus" styleClass="p-fluid" [modal]="true"
    [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <!-- INFO -->
            <div class="p-col-12">
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{lbl_service}}</span>
                    <span class="p-text-bold">{{workshop!= null ? workshop.wst.wsName
                        :""}}</span>
                </div>
                <div class="subTitle  p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_church}}</span>
                    <span class="p-text-bold">{{workshop != null ?workshop.churchAdress.name
                        :""}}</span>
                </div>
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_status}}</span>
                    <span class="p-text-bold">{{workshop != null ?workshop.statusName :
                        ""}}

                    </span>
                </div>

            </div>
        </div>
        <!-- INPUTS -->
        <div class="p-grid">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12">

                <div class="p-fluid">

                    <div class="p-col-12">
                        <label for="statusModal">{{lbl_select}} {{lbl_status}} <span *ngIf="!statusSelected"
                                style="color:red">(*)</span></label>
                        <p-dropdown id="statusModal" [options]="SchoolTranStsList" [(ngModel)]="statusSelected"
                            placeholder="{{lbl_select}} {{lbl_status}}" optionLabel="value"
                            [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Name -->
                    <div class="p-col-12">
                        <label for="dateModal">{{lbl_date}} <span *ngIf="!dateSelected" style="color:red">
                                (*)</span></label>
                        <p-inputMask id="dateModal" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            [(ngModel)]="dateSelected" placeholder="DD/MM/YYYY"></p-inputMask>

                    </div>

                    <!-- Comments -->
                    <div class="p-col-12">
                        <label for="commentsModal">{{lbl_comments}} <span *ngIf="!commentsSelected" style="color:red">
                                (*)</span></label>
                        <textarea id="commentsModal" [(ngModel)]="commentsSelected" rows="5" cols="30" pInputTextarea
                            autoResize="autoResize" maxlength="300" #myInput></textarea>
                        <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">

        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="displayModalStatus=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{lbl_save}}"
            class="p-button-raised p-button-success" (click)="updateStatus()"></button>
    </ng-template>
</p-dialog>